import { render, staticRenderFns } from "./UserProjectsCard.vue?vue&type=template&id=cfa07f0a&scoped=true"
import script from "./UserProjectsCard.vue?vue&type=script&lang=ts"
export * from "./UserProjectsCard.vue?vue&type=script&lang=ts"
import style0 from "./UserProjectsCard.vue?vue&type=style&index=0&id=cfa07f0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa07f0a",
  null
  
)

export default component.exports